import { render, staticRenderFns } from "./MessageSearched.vue?vue&type=template&id=13fc6aae"
import script from "./MessageSearched.vue?vue&type=script&lang=js"
export * from "./MessageSearched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports